import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { WEB_URL } from '../api/URLs';
import { UserService } from '../services/storage.service';

export const PrivateRoute = ({ children, ...props }) => {
   const location = useLocation();

   console.log(location)
   return UserService.isLoggedIn() ?
      <Outlet /> :
      <Navigate to={WEB_URL.LOGIN} state={{ from: location.pathname, ...location.state }} />
}
